import moment from "moment";

export const howMuchTimeSpent = (time: string) => {
  return moment(+time * 1000).fromNow(true);
};
